export function toRoman(num) {
  const map = [
    { value: 10, numeral: 'x' },
    { value: 9, numeral: 'ix' },
    { value: 5, numeral: 'v' },
    { value: 4, numeral: 'iv' },
    { value: 1, numeral: 'i' },
  ];

  let result = '';
  for (const { value, numeral } of map) {
    while (num >= value) {
      result += numeral;
      num -= value;
    }
  }
  return result;
}
